const BLOCKS = [
  { w: 44, h: 28, top: '8%', left: '5%', dur: 48, delay: 0, variant: 'blue' },
  { w: 72, h: 16, top: '18%', left: '78%', dur: 56, delay: -8, variant: 'teal' },
  { w: 28, h: 52, top: '42%', left: '12%', dur: 52, delay: -12, variant: 'navy' },
  { w: 56, h: 24, top: '65%', left: '68%', dur: 44, delay: -4, variant: 'blue' },
  { w: 36, h: 36, top: '28%', left: '42%', dur: 60, delay: -20, variant: 'teal' },
  { w: 88, h: 12, top: '78%', left: '22%', dur: 50, delay: -6, variant: 'navy' },
  { w: 24, h: 64, top: '12%', left: '88%', dur: 54, delay: -14, variant: 'blue' },
  { w: 48, h: 40, top: '52%', left: '88%', dur: 58, delay: -22, variant: 'teal' },
  { w: 64, h: 20, top: '88%', left: '8%', dur: 46, delay: -2, variant: 'blue' },
  { w: 32, h: 32, top: '72%', left: '45%', dur: 62, delay: -18, variant: 'navy' },
  { w: 52, h: 18, top: '5%', left: '35%', dur: 55, delay: -10, variant: 'teal' },
  { w: 20, h: 48, top: '38%', left: '92%', dur: 49, delay: -16, variant: 'blue' },
  { w: 40, h: 56, top: '22%', left: '58%', dur: 53, delay: -24, variant: 'navy' },
  { w: 76, h: 14, top: '92%', left: '55%', dur: 57, delay: -5, variant: 'teal' },
  { w: 30, h: 30, top: '48%', left: '28%', dur: 51, delay: -28, variant: 'blue' },
  { w: 60, h: 22, top: '15%', left: '18%', dur: 59, delay: -11, variant: 'teal' },
];

function DataBlocksBackground() {
  return (
    <div className="vivo-data-layer" aria-hidden="true">
      {BLOCKS.map((b, i) => (
        <div
          key={i}
          className={`vivo-data-block vivo-data-block--${b.variant}`}
          style={{
            width: b.w,
            height: b.h,
            top: b.top,
            left: b.left,
            animationDuration: `${b.dur}s`,
            animationDelay: `${b.delay}s`,
          }}
        />
      ))}
    </div>
  );
}

export default DataBlocksBackground;
